export const SITE_URL = 'https://kakobuypolska.casa';